import { createSelector } from "reselect";
import { RootState } from "./store";

const settingsSelector = (state: RootState) => state.settings;

const getCurrentPage = createSelector([settingsSelector], (state) => state.currentPage);
const getFullPageFlg = createSelector([settingsSelector], (state) => state.fullPageFlg);
const getIsModal = createSelector([settingsSelector], (state) => state.isModal);

export { getCurrentPage, getFullPageFlg, getIsModal };
